// extracted by mini-css-extract-plugin
export default {"growth":"changesLabel_growth__hpKKn","rise":"changesLabel_rise__luucO","fail":"changesLabel_fail__tE00R"};